import React from 'react';
import { motion } from 'framer-motion';
interface ChildSelectorProps {
  childrenList: {
    id: string;
    name: string;
  }[];
  selectedChildId: string;
  onSelectChild: (id: string) => void;
}
export function ChildSelector({
  childrenList,
  selectedChildId,
  onSelectChild
}: ChildSelectorProps) {
  return <div className="flex gap-2 p-1.5 bg-white rounded-2xl border border-slate-200 shadow-sm overflow-x-auto scrollbar-hide w-full sm:w-fit" data-id="element-4295">
      {childrenList.map(child => {
      const isSelected = child.id === selectedChildId;
      return <button key={child.id} onClick={() => onSelectChild(child.id)} className={`
              relative flex items-center gap-3 px-5 py-3 rounded-xl text-sm font-bold transition-all whitespace-nowrap
              ${isSelected ? 'text-emerald-900' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}
            `} data-id="element-4296">
            {isSelected && <motion.div layoutId="childSelectorBg" className="absolute inset-0 bg-emerald-100 rounded-xl -z-10 border border-emerald-200" transition={{
          type: 'spring',
          bounce: 0.2,
          duration: 0.6
        }} data-id="element-4297" />}
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-xs ${isSelected ? 'bg-emerald-500' : 'bg-slate-300'}`} data-id="element-4298">
              {child.name.charAt(0).toUpperCase()}
            </div>
            {child.name}
          </button>;
    })}
    </div>;
}